import { render } from "./LawyerMoreDetailsModal.vue?vue&type=template&id=c9013244"
import script from "./LawyerMoreDetailsModal.vue?vue&type=script&lang=js"
export * from "./LawyerMoreDetailsModal.vue?vue&type=script&lang=js"

import "./LawyerMoreDetailsModal.vue?vue&type=style&index=0&id=c9013244&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__